import {Product} from "../model/types";

export const getPriceMeta = (product: Product) => {
    const current = product.card_price;
    const original = product.price;

    const hasDiscount = current !== null && original !== null && current !== original;

    return {
        current,
        original,
        hasDiscount,
        discount: product.card_discount,
        discountColor: product.marker_discount_color,
        discountBg: product.marker_discount_bg_color,
    };
};
